export const SelectIconModalTitleStyle = {
  title: {
    display: 'flex',
    marginBottom: '16px',
    alignItems: 'center',
  },
  close: {
    style: {
      marginLeft: 'auto',
      cursor: 'pointer',
      width: '18px',
      height: '18px',
    },
    sx: {
      color: 'text.secondary',
    },
  },
  header: {
    fontSize: '18px',
    fontWeight: '600',
  },
};
